import { useState } from "react";
import { StatusBadge } from "../../../Component/MiscComponent/PrimitiveComponent";
import { DateFormatter, fIDR } from "../../../Service/Helper/Utils";

export const HistoryContent = ({ data }) => {
  const [sel, setSel] = useState(null);
  const historyStats = (sel) => [
    [
      "Pelanggan",
      sel.customerName
    ],
    [
      "Email",
      sel.customerEmail
    ],
    [
      "Periode Mulai",
      `${sel.periodStart?.trim()} ${sel.yearStart}`
    ],
    [
      "Periode Selesai",
      `${sel.periodEnd?.trim()} ${sel.yearEnd}`
    ],
    [
      "Tanggal Mulai",
      DateFormatter(sel.startDate)
    ],
    [
      "Tanggal Akhir",
      DateFormatter(sel.endDate)
    ],
    [
      "Jatuh Tempo",
      DateFormatter(sel.due)
    ],
    [
      "Dibayar Pada",
      DateFormatter(sel.date)
    ],
    [
      "Reseller",
      sel.mitra_name
    ],
    [
      "Total",
      sel.total === "0"
      ? "Lunas (diskon penuh)"
      : fIDR(sel.total)
    ]
  ]

  return (
    <div style={{ display:"flex", flexDirection:"column", gap:20 }}>
      <div>
        <div style={{ fontSize:20, fontWeight:800, marginBottom:4 }}>Riwayat Pembayaran</div>
        <div className="txt-muted">List Semua tagihan yang telah dibayarkan</div>
      </div>
      <div className="grid-12" style={{ gridTemplateColumns:"5fr 7fr" }}>
        <div className="card" style={{ overflow:"hidden", padding:0 }}>
          {data.paidPeriod.map(item => (
            <div key={item.id} className={`hist-item ${sel?.id === item.id ? "selected" : ""}`} onClick={()=>setSel(!sel ? item : null)}>
              <div className="flex justify-between items-center gap-2">
                <div>
                  <div className="hist-title" style={{ fontSize:14, fontWeight:600, marginBottom:4 }}>{item.periodStart?.trim()} {item.yearStart} - {item.periodEnd?.trim()} {item.yearEnd}</div>
                  <div className="txt-muted" style={{ fontSize:12 }}>{DateFormatter(item.date)}</div>
                </div>
                <StatusBadge paid={item.paid} />
              </div>
                {
                (sel?.id === item.id) ? (
                    <div className="card anim-scale-in">
                        <div className="card-header" style={{ marginBottom:16 }}>
                        <div style={{ fontSize:16, fontWeight:700, marginBottom:4 }}>Detail Pembayaran</div>
                        <div className="mono txt-muted" style={{ fontSize:11, wordBreak:"break-all" }}>{sel.id}</div>
                        </div>
                        <div className="card-body">
                        <div className="info-grid">
                            {historyStats(sel).map(([l,v])=>(
                            <div className="info-cell" key={l}>
                                <div className="info-label">{l}</div>
                                <div className="info-val">{v}</div>
                            </div>
                            ))}
                        </div>
                        <div style={{ marginTop:16 }}><StatusBadge paid={sel.paid}/></div>
                        </div>
                    </div>
                    ) : (
                    <div className="card" style={{ display:"flex", alignItems:"center", justifyContent:"center", textAlign:"center", padding:10 }}>
                        <div>
                            <div style={{ fontSize:30, marginBottom:12 }}>
                                <i className="fa fa-file-invoice-dollar"></i>
                            </div>
                            <div className="txt-muted">Klik untuk melihat detail pembayaran</div>
                        </div>
                    </div>
                )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};